import { render, staticRenderFns } from "./ClientCaseSelector.vue?vue&type=template&id=65a56512"
import script from "./ClientCaseSelector.vue?vue&type=script&lang=js"
export * from "./ClientCaseSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports